import { render, staticRenderFns } from "./SalesDetailOrderService.vue?vue&type=template&id=16c5ef86&scoped=true&"
import script from "./SalesDetailOrderService.vue?vue&type=script&lang=js&"
export * from "./SalesDetailOrderService.vue?vue&type=script&lang=js&"
import style0 from "./SalesDetailOrderService.vue?vue&type=style&index=0&id=16c5ef86&lang=scss&scoped=true&"
import style1 from "./SalesDetailOrderService.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5ef86",
  null
  
)

export default component.exports